import React, {Component} from "react";

class NotFound extends Component {
    render() {
        return (
            <div>
                404 not found
            </div>
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/error/not.found.jsx